import React from 'react'
import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import { makeStyles } from '@material-ui/core'
import { useIntl } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  endAdornment: {
    width: '100%',
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}))

const SimpleAutocomplete = ({
  id,
  options,
  value,
  onChange,
  placeholder,
  className,
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.label}
      value={options.find((g) => g.value === value) || null}
      className={className}
      noOptionsText={formatMessage({
        id: 'crm.form.receiveMethods.option.empty',
      })}
      onChange={(event, newValue) => {
        if (onChange) {
          onChange(newValue ? newValue.value : '')
        }
      }}
      renderInput={(params) => (
        <div ref={params.InputProps.ref} className="w-full">
          <SimpleInput
            id={id}
            placeholder={placeholder}
            endAdornment={
              <div className={classes.endAdornment}>
                {params.InputProps.endAdornment}
              </div>
            }
            size="medium"
            fullWidth
            {...params}
          />
        </div>
      )}
    />
  )
}

SimpleAutocomplete.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ).isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
}

export default SimpleAutocomplete
